import { IconTypesProps } from '@/ui/components/svg/iconTypes'
import { Circle, Path, Svg } from '@react-pdf/renderer'

const SvgStatusApproved = ({ primaryColor = '#FFFFFF' }: IconTypesProps) => (
    <Svg width="20" height="20" viewBox="0 0 24 24">
        <Circle cx="12" cy="12" r="12" fill="#CCCCCC" />
        <Path
            d="M7.85156 17.75V5.75H16.1484V17.75L12 15.2539L7.85156 17.75ZM8.60156 16.3906L12 14.3516L15.3984 16.3906V6.5H8.60156V16.3906ZM14.4609 9.40625L11.168 12.6992L9.39844 10.918L9.92578 10.3906L11.168 11.6328L13.9219 8.87891L14.4609 9.40625Z"
            fill={primaryColor}
        />
    </Svg>
)

export default SvgStatusApproved
